import { Platform, Share } from 'react-native';

export interface ShareableWorkout {
  exercises: { name: string; topSet: string; isPR: boolean }[];
  totalVolume: number;
  unit: string;
  date: string;
  handle: string;
  strengthScore: number;
}

export function generateShareText(workout: ShareableWorkout): string {
  const exerciseLines = workout.exercises
    .slice(0, 5)
    .map((e) => `${e.name} ${e.topSet}${e.isPR ? ' (PR!)' : ''}`)
    .join(', ');

  const volumeStr = workout.totalVolume.toLocaleString();

  return `Just crushed it at the gym! 🏋️ ${exerciseLines}. Total volume: ${volumeStr} ${workout.unit}. #DUEL #StrengthStandard`;
}

export async function shareWorkout(workout: ShareableWorkout): Promise<void> {
  const text = generateShareText(workout);

  if (Platform.OS === 'web') {
    if (typeof navigator !== 'undefined' && navigator.share) {
      try {
        await navigator.share({ text });
        return;
      } catch {
        // User cancelled or API unavailable — fall through to clipboard
      }
    }
    // Fallback: copy to clipboard
    if (typeof navigator !== 'undefined' && navigator.clipboard) {
      await navigator.clipboard.writeText(text);
    }
    return;
  }

  await Share.share({ message: text });
}
